/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Types de fichiers supportés par le système
 * @export
 */
export const FileTypeEnum = {
    PhotoBienImmobilier: 1,
    IconeGarantieTunnel: 2,
    DocumentLocataire: 3,
    PhotoAssure: 4,
    Document: 5,
    DocumentGenerer: 6,
    DocumentSigner: 7,
    ThemeLogo: 8,
    SimulationPdfGenerer: 9,
    DevisPdfGenerer: 10,
    ContratPdfGenerer: 11,
    AdviceSheetPdfGenerer: 12,
    OriasPreuve: 13,
    RcpCertificat: 14,
    AttestationAssurance: 15,
    AttestationSinistre: 16,
    AvenantPdfGenerer: 17,
    ExportCSV: 18,
    BordereauCommissionCSV: 19,
    ContratGroupePdfGenerer: 20,
    CourtierPresentation: 21,
    ConditionsParticulieres: 22,
    QuittanceGenerer: 23,
    CertificatAdhesion: 24,
    ContratSigne: 25,
    PreuveSignature: 26,
    BulletinAdhesion: 27,
    FicheProduit: 28,
    Ipid: 29,
    Notice: 30,
    SimulationComplete: 31,
    BulletinAdhesionSigne: 32,
    ContratTravail: 33,
    AttestationEmployeur: 34,
    BulletinSalaireM1: 35,
    AvisImposition: 36,
    AttestationRessources: 37,
    DecompteRetraite: 38,
    CarteEtudiant: 39,
    CertificatScolarite: 40,
    ContratApprentissage: 41,
    TitreSejour: 42,
    PieceIdentite: 43,
    ConditionsSpeciales: 45,
    JustificatifDomicile: 46,
    JustificatifAideSociale: 47,
    BulletinSalaireM2: 48,
    BulletinSalaireM3: 49,
    PieceIdentiteLocataire: 50,
    QuestionnaireSante: 51,
    BonPourAccord: 52,
    QuestionnaireSanteSigne: 53,
    BonPourAccordSigne: 54,
    LogoPlateforme: 55,
    LogoMinimalPlateforme: 56,
    LogoProduit: 57,
    Rib: 58,
    MandatSepa: 59,
    Ppe: 60,
    Aeras: 61,
    Fsi: 62,
    QuestionnaireSanteRetourMoteur: 63,
    Kbis: 64,
    ResultatFicheMedicale: 65,
    MandatSubstitutionAssurance: 66,
    MandatSubstitutionAssuranceSigne: 67,
    CourrierSubstitutionAssurance: 68,
    OffreDePret: 69,
    TableauAmortissement: 70,
    LiasseBanqueSubstitution: 71,
    ReleveInformationSinistralite: 72
} as const;
export type FileTypeEnum = typeof FileTypeEnum[keyof typeof FileTypeEnum];


export function instanceOfFileTypeEnum(value: any): boolean {
    for (const key in FileTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(FileTypeEnum, key)) {
            if (FileTypeEnum[key as keyof typeof FileTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FileTypeEnumFromJSON(json: any): FileTypeEnum {
    return FileTypeEnumFromJSONTyped(json, false);
}

export function FileTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileTypeEnum {
    return json as FileTypeEnum;
}

export function FileTypeEnumToJSON(value?: FileTypeEnum | null): any {
    return value as any;
}

export function FileTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): FileTypeEnum {
    return value as FileTypeEnum;
}

